import React, { memo } from 'react';
import { Box, useTheme } from '@mui/material';

interface ProfileProps {
    name: string;
    open?: boolean;
}
/* eslint-disable react/prop-types */
export const Profile: React.FC<ProfileProps> = memo(({ name, open }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                backgroundColor: theme.palette.teal.main,
                borderRadius: '100%',
                width: '2.5rem',
                height: '2.5rem',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: 'surface.main',
                ...theme.typography['paragraph-bold']
            }}
        >
            {name}
        </Box>
    );
});

Profile.displayName = 'Profile';

export default Profile;
